export enum NoteBlockStatus {
	NOT_DONE = "not_done",
	DONE = "done",
	WONT_DO = "wont_do",
}

export enum StatusCondition {
	SINGLE = "SINGLE",
	ALL = "ALL",
}
